// File: src/contexts/MissingCorpPrefixAlertContext.jsx
import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import MissingCorpPrefixAlert from "../components/MissingCorpPrefixAlert";
import { useAuth } from "./AuthContext"; // Assuming AuthContext provides user authentication state
import { BASE_URL } from "../config";

const MissingCorpPrefixAlertContext = createContext();

export const MissingCorpPrefixAlertProvider = ({ children }) => {
  const [showAlert, setShowAlert] = useState(false);
  const { isAuthenticated } = useAuth(); // Assuming AuthContext provides isAuthenticated

  useEffect(() => {
    if (!isAuthenticated) return; // Only check if user is authenticated

    const checkMissingCorpPrefix = async () => {
      try {
        // const response = await axios.get(`${BASE_URL}/network-access-fee/corporations`, {
        const response = await axios.get(`${BASE_URL}/missing-corp-prefix`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        if (response.data.data.corporates.length > 0) {
          setShowAlert(true);
        }
      } catch (err) {
        console.error("Error checking missing corp_prefix:", err);
      }
    };

    checkMissingCorpPrefix();
  }, [isAuthenticated]);

  return (
    <MissingCorpPrefixAlertContext.Provider value={{ showAlert, setShowAlert }}>
      {showAlert && <MissingCorpPrefixAlert onClose={() => setShowAlert(false)} />}
      {children}
    </MissingCorpPrefixAlertContext.Provider>
  );
};

export const useMissingCorpPrefixAlert = () => useContext(MissingCorpPrefixAlertContext);